import React from 'react'
import { PropTypes } from 'prop-types'
import Link from 'components/Link'

import Icon from 'components/Icon'

import './back-navigation.pcss'

const BackNavigation = ({ to, target, text, title, onClick, trackName }) => {
    return (
        <nav className="back-navigation">
            <div className="back-navigation__action">
                <Link
                    to={to}
                    title={title || text}
                    target={target}
                    onClick={(e) => {
                        onClick && onClick(e)
                    }}
                    trackName={trackName || 'back'}
                >
                    <Icon name="icon_chevron_left" />{text}
                </Link>
            </div>
        </nav>
    )
}

BackNavigation.propTypes = {
    to: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    target: PropTypes.string,
}

export default React.memo(BackNavigation)
